"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberInput = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_phone_input_2_1 = tslib_1.__importDefault(require("react-phone-input-2"));
require("react-phone-input-2/lib/style.css");
var PhoneNumberInput_style_1 = require("./PhoneNumberInput.style");
exports.PhoneNumberInput = function (_a) {
    var label = _a.label, placeholder = _a.placeholder, value = _a.value, name = _a.name, onChange = _a.onChange, onBlur = _a.onBlur, validation = _a.validation, preferredCountries = _a.preferredCountries, disabled = _a.disabled, required = _a.required, country = _a.country, localization = _a.localization;
    var classes = PhoneNumberInput_style_1.usePhoneNumberInputStyles();
    var requiredLabel = required ? '*' : '';
    return (react_1.default.createElement("div", { className: classes.root },
        label && react_1.default.createElement("span", { className: "" + classes.label }, label + " " + requiredLabel),
        react_1.default.createElement(react_phone_input_2_1.default, { value: value, disabled: disabled, inputProps: {
                name: name,
                required: required,
                'data-signa': "phone-number-input-" + name,
            }, country: country, isValid: function () { return !(validation && validation.isError); }, defaultErrorMessage: validation ? validation.message : undefined, placeholder: placeholder, onChange: onChange, onBlur: onBlur, containerClass: classes.container, inputClass: classes.input, buttonClass: classes.flagButton, dropdownClass: classes.dropdown, preferredCountries: preferredCountries, localization: localization })));
};
